import React, { Component } from 'react';
import { Form, Input, Button, message } from 'antd';
import md5 from 'blueimp-md5';

const FormItem = Form.Item;

class UpdatePassword extends Component {
  submit = e => {
    e.preventDefault();
    const { handSubmit, user } = this.props;
    const userData = this.props.form.getFieldsValue();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (userData.oldPassword === userData.password) {
          message.error('新密码不能和旧密码相同！');
        } else if (userData.password !== userData.passwordConfirmation) {
          message.error('两次输入密码不一致！');
        } else {
          userData.oldPassword = md5(userData.oldPassword);
          userData.password = md5(userData.password);
          userData.passwordConfirmation = md5(userData.passwordConfirmation);
          handSubmit(userData);
        }
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form
        onSubmit={this.submit}
        className=""
        layout="vertical"
        style={{ height: '365px', marginTop: '-10px' }}
      >
        <FormItem label="原密码">
          {getFieldDecorator('oldPassword', {
            rules: [{ required: true, message: '原密码不能为空！' }],
          })(<Input type="password" />)}
        </FormItem>
        <FormItem label="新密码">
          {getFieldDecorator('password', {
            rules: [
              {
                required: true,
                message: '请输入包含数字和字母的6~16位新密码!',
                pattern: /(?!^\d+$)(?!^[A-z]+$)(?!^[^\dA-z]+$)^.{6,16}$/,
              },
            ],
          })(<Input placeholder="大于6位的数字或字母" type="password" />)}
        </FormItem>
        <FormItem label="确认新密码">
          {getFieldDecorator('passwordConfirmation', {
            rules: [
              {
                required: true,
                message: '请输入包含数字和字母的6~16位新密码!',
                pattern: /(?!^\d+$)(?!^[A-z]+$)(?!^[^\dA-z]+$)^.{6,16}$/,
              },
            ],
          })(<Input type="password" />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit">
            保存
          </Button>
        </FormItem>
      </Form>
    );
  }
}

export default Form.create()(UpdatePassword);



// WEBPACK FOOTER //
// ./src/components/home/UpdatePassword.js